<template>
    <div>
        <div class="pdetail-elements-group mgb-3">
            <div class="pdetail-header">
                <h3>
                    <i class="fad fa-city"></i>
                    <span> Alege Bloc </span>
                </h3>
                <button type="button" class="general-btn positive-btn" @click="openAddBuildingModal(projectId)">
                    <span><i class="fas fa-plus"></i> Adauga bloc </span>
                </button>
            </div>
            <ul class="checkboxes-list">
                <li class="text-placeholder-radio text-placeholder-radio--stack" v-for="(building, key) in buildings" :key="key">
                    <input type="radio" :id="`buildingApartmentsCommercialPanelblockId${building.id}`"
                           name="buildingApartmentsCommercialRadio" v-model="selectedBuildingId" :value="building.id"
                           class="text-checkbox-input" @change="setBuildingsFilter(building)" >
                    <label :for="`buildingApartmentsCommercialPanelblockId${building.id}`" class="radio-input-stack">
                        <span> Bloc {{ building.name }}</span>
                        <div class="radio-input-stack__line">&nbsp;</div>
                        <span v-if="building.finalized_date">{{building.finalized_date}}</span>
                        <span v-else>-</span>
                        <div class="radio-input-stack__count" data-toggle="tooltip" data-placement="top" title="Numar apartamente & spatii disponibile">
                            {{ building.items.filter(ap => ap.status === "available").length }}
                        </div>
                    </label>
                    <div class="radio-input-stack__actions">
                        <i class="fas fa-edit" @click="openEditBuildingModal(building.id, 'apartment')" v-if="canManage" data-toggle="tooltip" data-placement="top" title="Modifica bloc"></i>
                        <i class="fas fa-trash-alt" @click="removeBuilding(building)" v-if="canManage"  data-toggle="tooltip" data-placement="top" title="Sterge bloc"></i>
                    </div>
                </li>
            </ul>
        </div>

        <h5 class="building-name" v-if="selectedBuildingId">Bloc {{ selectedBuildingName }} <span>Total oferte: {{ selectedBuildingAllItems }} / Oferte disponibile: {{ selectedBuildingAvailableItems }}</span></h5>

        <div class="pdetail-levels-container levels-container" :key="levelsKey">
            <div class="single-level-wrapper" v-for="(level, key) in displayLevels" :key="key">
                <h3> {{ level.name }} <span v-if="selectedBuildingId">(Bloc {{ selectedBuildingName }})</span> </h3>
                <div class="add-field-btn"
                     @click="openAddModelToLevel(level.id)">
                    <i class="fad fa-plus-circle"></i> Adauga
                </div>
                <div v-if="reloadLevelId !== level.id">
                    <div class="single-level-row pdetail-level-row" v-for="(item, key) in level.items" :key="key" :class="(item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available')">
                        <div class="row" :id="`item_${item.id}`">
                            <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-item-nr level-strip-cell" v-if="item.type == 'apartment'">
                                    <p class="level-cell-heading"> Nr Ap. </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ item.apartment_number }} </p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="apartment_number" v-model="editableItems[item.id].apartment_number">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-strip-cell">
                                    <p class="level-cell-heading"> Model </p>
                                    <p class="highlighted-info-strip">
                                        <a :href="`/developer/project/${projectId}/model/${item.model.id}/details?client=${urlParams.client}`" class="general-link" v-if="urlParams && urlParams.client">
                                            <i class="fad fa-external-link"></i>
                                            <span v-if="item.type != 'commercial'">
                                                {{ item.model.rooms_count ? item.model.rooms_count.name : '' }} tip {{ item.model.model_type }}
                                            </span>
                                            <span v-if="item.type == 'commercial'">
                                                Spatiu comercial tip {{ item.model.model_type }}
                                            </span>
                                        </a>
                                        <a :href="`/developer/project/${projectId}/model/${item.model.id}/details`" class="general-link" v-else>
                                            <i class="fad fa-external-link"></i>
                                            <span v-if="item.type != 'commercial'">
                                                {{ item.model.rooms_count ? item.model.rooms_count.name : '' }} tip {{ item.model.model_type }}
                                            </span>
                                            <span v-if="item.type == 'commercial'">
                                                Spatiu comercial tip {{ item.model.model_type }}
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <p class="level-cell-heading"> Suprafata</p>
                                <div class="level-item-size level-strip-cell pdetail-level-cell pdetail-level-cell--column">
                                    <div class="pdetail-surface-type">
                                        <span> Totala: </span>
                                        <span v-if="!isItemInEditMode(item.id)"> {{ item.useful_surface }} (m²)</span>
                                        <div class="input-container" v-if="isItemInEditMode(item.id)">
                                            <div class="input-group mg-b">
                                                <input type="number" class="useful_surface" v-model="editableItems[item.id].useful_surface">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pdetail-surface-type">
                                        <span> Balcon: </span>
                                        <span v-if="!isItemInEditMode(item.id)"> {{ item.terrace_surface }} (m²)</span>
                                        <div class="input-container" v-if="isItemInEditMode(item.id)">
                                            <div class="input-group mg-b">
                                                <input type="number" class="terrace_surface" v-model="editableItems[item.id].terrace_surface">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret (EUR) </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ itemPrices[item.id] }} ({{ itemPricesWithVat[item.id] ? 'TVA inclus' : '+TVA' }})</p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="price" v-model="editableItems[item.id].price">
                                        </div>
                                    </div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].price_with_vat">
                                                <option value="0"> +TVA </option>
                                                <option value="1"> TVA Inclus </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret cu credit (EUR) </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id) && item.credit_price"> {{ itemCreditPrices[item.id] }} ({{ itemCreditPricesWithVat[item.id] ? 'TVA inclus' : '+TVA' }}) </p>
                                    <p class="highlighted-info-strip" v-else-if="!isItemInEditMode(item.id)"> -- </p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="credit_price" v-model="editableItems[item.id].credit_price">
                                        </div>
                                    </div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].credit_price_with_vat">
                                                <option value="0"> +TVA </option>
                                                <option value="1"> TVA Inclus </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-item-size level-strip-cell">
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'available'" style="display: flex;"> Status <span class="highlighted-info-strip"> Disponibil</span></div>
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'reserved'" style="display: flex;"> Status <span class="highlighted-info-strip"> Rezervat</span></div>
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'sold'" style="display: flex;"> Status <span class="highlighted-info-strip"> Vandut</span></div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].status">
                                                <option value="available"> Disponibil</option>
                                                <option value="reserved"> Rezervat</option>
                                                <option value="sold"> Vandut</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-strip-cell">
                                    <div class="list-item-actions">
                                        <a href="javascript:void(0)"
                                        @click="openItemDetailModal(item.id, canManage)"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Vezi Detalii"
                                        >
                                            <i class="fad fa-eye"></i>
                                        </a>
                                        <a href="javascript:void(0)"
                                        v-if="canManage"
                                        @click="openEditInlineModelItem(item)"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Modifica"
                                        >
                                            <i class="fad fa-edit"></i>
                                        </a>
                                        <a href="javascript:void(0)"
                                        v-if="canManage"
                                        @click="deleteItem(item)"
                                        class="item-action-btn"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        :title="`Sterge ${item.type == 'apartment' ? 'Apartament': 'Spatiu'}`"
                                        >
                                            <i class="fad fa-trash-alt"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="level-strip-cell level-strip-cell--edit" v-if="isItemInEditMode(item.id)">
                                    <div class="list-item-actions list-item-actions--edit">
                                        <a href="javascript:void(0)"
                                        @click="cancelEditInlineModelItem(item)"
                                        class="developer-list-edit-button developer-list-edit-button--cancel"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Anulează modificările"
                                        >
                                            Anulează
                                        </a>
                                        <a href="javascript:void(0)"
                                        @click="saveInlineModelItem(item.id)"
                                        v-if="canManage"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Salvează modificările"
                                        class="developer-list-edit-button"
                                        >
                                            Salvează
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h5 class="building-name" v-if="selectedBuildingId && selectedBuildingAllItems > 0">Bloc {{ selectedBuildingName }} <span>Total oferte: {{ selectedBuildingAllItems }} / Oferte disponibile: {{ selectedBuildingAvailableItems }}</span></h5>
    </div>
</template>

<script>
    export default {
        name: "DeveloperListApartmentCommercialBuildings",
        props: ['projectId','canManage'],
        components: {
            // editor
        },
        data() {
            return {
                levels: [],
                roomsCountFilter: [],
                selectedBuildingId: null,
                buildings: [],
                levelsKey: 1,
                urlParams: null,
                inlineEditItems: [],
                addModelToLevelId: null,
                reloadLevelId: null,
                newItemId: -1,
            }
        },
        async created() {
            let vm = this
            this.urlParams = window.getAllUrlParams();
            this.$eventBus.$on('MODEL_ITEMS_CHANGED', function () {
                vm.getBuildingsData()
            });
            this.$eventBus.$on('CLIENT_ASSIGNED', function () {
                vm.getBuildingsData()
            });
            this.$eventBus.$on('ITEM_DETAIL_SAVED', function () {
                vm.getBuildingsData()
            });
            this.$eventBus.$on('MODEL_SELECTED', function (payLoad) {
                if(payLoad.model && vm.selectedBuildingId && vm.addModelToLevelId) {
                    vm.addModelToLevel(payLoad.model, vm.selectedBuildingId, vm.addModelToLevelId);
                }
            });
            await vm.getBuildingsData();
        },
        computed: {
            displayLevels() {
                let output = []
                for (let i in this.levels) {
                    // if (this.levels[i].items.length) {
                        output.push(this.levels[i])
                    // }
                }
                output.sort(function(a, b) { return a.sort_order - b.sort_order});
                return output;
            },
            selectedBuildingName() {
                let vm = this;
                let selected = vm.buildings.find(b => b.id === vm.selectedBuildingId);
                return selected ? selected.name : null;
            },
            selectedBuildingAllItems() {
                let vm = this;
                let selected = vm.buildings.find(b => b.id === vm.selectedBuildingId);
                return selected ? selected.items.length : 0;
            },
            selectedBuildingAvailableItems() {
                let vm = this;
                let selected = vm.buildings.find(b => b.id === vm.selectedBuildingId);
                return selected ? selected.items.filter(ap => ap.status === "available").length : 0;
            },
            editableItems() {
                let items = [];
                this.inlineEditItems.forEach(function (item){
                    items[item.id] = item;
                })
                return items;
            },
            itemPrices() {
                let vm = this;
                let prices = [];
                vm.buildings.forEach(function (building){
                    building.items.forEach(function (item){
                        prices[item.id] = vm.formatPrice(item.price, false);
                    });
                });
                return prices;
            },
            itemPricesWithVat() {
                let vm = this;
                let result = [];
                vm.buildings.forEach(function (building){
                    building.items.forEach(function (item){
                        result[item.id] = item.price_with_vat;
                    });
                });
                return result;
            },
            itemCreditPrices() {
                let vm = this;
                let prices = [];
                vm.buildings.forEach(function (building){
                    building.items.forEach(function (item){
                        prices[item.id] = vm.formatPrice(item.credit_price, false);
                    });
                });
                return prices;
            },
            itemCreditPricesWithVat() {
                let vm = this;
                let result = [];
                vm.buildings.forEach(function (building){
                    building.items.forEach(function (item){
                        result[item.id] = item.credit_price_with_vat;
                    });
                });
                return result;
            },
        },
        methods: {
            setBuildingsFilter(building) {
                this.selectedBuildingId = building.id;
                this.levels = building.levels
                for (let i in this.levels) {
                    this.levels[i].items = building.items.filter(item => item.level_id === this.levels[i].id)
                }
            },
            getBuildingsData() {
                let vm = this
                window.axios.get(`/ajax/get-all-buildings-by-model-types-with-items/${this.projectId}/apartment-commercial`)
                    .then(function (resp) {
                        vm.buildings = resp.data.data
                        if (vm.buildings.length > 0) {
                            let selected = null
                            let defaultSelected = null
                            if (vm.selectedBuildingId) {
                                selected = vm.buildings.find(b => b.id === vm.selectedBuildingId)
                            } else {
                                defaultSelected = vm.buildings.find(b => b.total_items > 0)
                                defaultSelected = defaultSelected ? defaultSelected : vm.buildings[0]
                            }
                            selected = selected ? selected : defaultSelected;

                            vm.setBuildingsFilter(selected)
                            vm.levelsKey++
                        }
                    })
                    .catch(function (err) {
                        window.showError(err)
                    });
            },
            removeBuilding: function (building) {
                let vm = this
                window.Swal.fire({
                    title:'Atentie!',
                    text: 'Sunteti sigur ca vreti sa stergeti blocul?',
                    icon:'warning',
                    showCancelButton:true,
                    confirmButtonText:'Da, sterge!',
                    cancelButtonText:"Renunta"
                }).then((result) => {
                    if(result.value) {
                        window.axios.post(
                            '/ajax/developer/deleteProjectBuilding',
                            {
                                'projectId': this.projectId,
                                'buildingId': building.id,
                            },
                            {
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                }
                            }
                        )
                            .then(function () {
                                window.Swal.fire({
                                    html: 'Blocul a fost sters cu succes.',
                                    icon: 'success',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(() => {
                                    window.location.href = "/developer/project/".concat(vm.projectId, "?tab=apartmentSpace-buildings");
                                })
                            })
                            .catch(function (err) {
                                window.showError(err)
                            });
                    }
                });
            },
            openEditInlineModelItem(item) {
                let clone = Object.assign({}, item);
                this.inlineEditItems.push(clone);
            },
            cancelEditInlineModelItem(item) {
                this.inlineEditItems = this.inlineEditItems.filter(editItem => item.id != editItem.id);

                // if item is added inline
                if(item.id < 0) {
                    let building = this.buildings.find(b => b.id === item.project_building_id);
                    // delete row and "reload"
                    this.reloadLevelId = item.level_id;
                    for (let i = 0; i < building.items.length; i++) {
                        if (building.items[i].id === item.id) {
                            building.items.splice(i, 1);
                        }
                    }
                    this.setBuildingsFilter(building);
                    this.reloadLevelId = null;
                }
            },
            isItemInEditMode(itemId) {
                return this.inlineEditItems.find(item => item.id == itemId);
            },
            saveInlineModelItem(itemId) {
                let vm = this;
                let isAddAction = itemId < 0;
                let editedItem = vm.editableItems[itemId];
                if(!editedItem) {
                    window.showError('Item invalid');
                    return;
                }

                let apartmentNumber = editedItem.apartment_number ? editedItem.apartment_number+'' : '';
                let usefulSurface = editedItem.useful_surface ? editedItem.useful_surface+'' : '';
                let terraceSurface = editedItem.terrace_surface ? editedItem.terrace_surface+'' : '';
                let price = editedItem.price ? editedItem.price+'' : '';
                let priceWithVat = editedItem.price_with_vat ? editedItem.price_with_vat+'' : '';
                let creditPrice = editedItem.credit_price ? editedItem.credit_price+'' : '';
                let creditPriceWithVat = editedItem.credit_price_with_vat ? editedItem.credit_price_with_vat+'' : '';
                let status = editedItem.status ? editedItem.status+'' : '';

                let formData = new FormData();
                formData.append('apartmentNumber', apartmentNumber);
                formData.append('usefulSurface', usefulSurface);
                formData.append('terraceSurface', terraceSurface);
                formData.append('price', price);
                formData.append('priceWithVat', priceWithVat);
                formData.append('creditPrice', creditPrice);
                formData.append('creditPriceWithVat', creditPriceWithVat);
                formData.append('status', status);

                if(isAddAction) {
                    window.axios.post('/developer/'+vm.projectId+'/model/'+editedItem.project_model_id+'/building/'+editedItem.project_building_id+'/level/'+editedItem.level_id+'/add-item', formData)
                        .then(function (response) {
                            let html = ''
                            if (response.data.data.type === 'apartment') {
                                html = "Apartamentul a fost adaugat cu succes."
                            } else if (response.data.data.type === 'house') {
                                html = "Casa a fost adaugata cu succes."
                            } else if (response.data.data.type === 'commercial') {
                                html = "Spatiul comercial a fost adaugat cu succes."
                            }

                            let building = vm.buildings.find(b => b.id === editedItem.project_building_id);
                            // replace row and "reload"
                            vm.reloadLevelId = editedItem.level_id;
                            for (let i = 0; i < building.items.length; i++) {
                                if (building.items[i].id === editedItem.id) {
                                    building.items[i].id = response.data.data.id;
                                    building.items[i] .apartment_number = response.data.data.apartment_number;
                                    building.items[i] .useful_surface = response.data.data.useful_surface;
                                    building.items[i] .terrace_surface = response.data.data.terrace_surface;
                                    building.items[i] .price = response.data.data.price;
                                    building.items[i] .price_with_vat = response.data.data.price_with_vat;
                                    building.items[i] .credit_price = response.data.data.credit_price;
                                    building.items[i] .credit_price_with_vat = response.data.data.credit_price_with_vat;
                                    building.items[i] .status = response.data.data.status;
                                }
                            }
                            vm.setBuildingsFilter(building);
                            vm.reloadLevelId = null;
                            vm.cancelEditInlineModelItem(editedItem);

                            window.Swal.fire({
                                html: html,
                                icon: 'success',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            })
                        })
                        .catch(function (err) {
                            window.showError(err);
                            let isValidationError = err.response && err.response.status == 422;
                            if(!isValidationError) {
                                // force reload to prevent data inconsistency
                                setTimeout(function(){ window.location.reload(); }, 5000);
                            }
                        });
                } else {
                    window.axios.post('/developer/' + vm.projectId + '/model/' + editedItem.project_model_id + '/item/' + itemId + '/edit', formData)
                        .then(function (response) {
                            let html = ''
                            if (response.data.data.type === 'apartment') {
                                html = "Apartamentul a fost modificat cu succes."
                            } else if (response.data.data.type === 'house') {
                                html = "Casa a fost modificata cu succes."
                            } else if (response.data.data.type === 'commercial') {
                                html = "Spatiul comercial a fost modificat cu succes."
                            }

                            for (let i in vm.levels) {
                                vm.levels[i].items.forEach(function (item) {
                                    if (item.id == response.data.data.id) {
                                        item.apartment_number = response.data.data.apartment_number;
                                        item.useful_surface = response.data.data.useful_surface;
                                        item.terrace_surface = response.data.data.terrace_surface;
                                        item.price = response.data.data.price;
                                        item.price_with_vat = response.data.data.price_with_vat;
                                        item.credit_price = response.data.data.credit_price;
                                        item.credit_price_with_vat = response.data.data.credit_price_with_vat;
                                        item.status = response.data.data.status;
                                        vm.cancelEditInlineModelItem(item);
                                    }
                                })
                            }

                            window.Swal.fire({
                                html: html,
                                icon: 'success',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            })
                        })
                        .catch(function (err) {
                            window.showError(err)
                        });
                }
            },
            openAddModelToLevel(levelId) {
                let vm = this;
                vm.addModelToLevelId = levelId;
                vm.openChooseModelModal(vm.projectId, 'apartment-commercial')
            },
            addModelToLevel(model, buildingId, levelId) {
                if(!model) {
                    window.showError('Model invalid');
                    return;
                }

                let building = this.buildings.find(b => b.id === buildingId);
                let level = building.levels.find(l => l.id === levelId);

                let item = {
                    advance_amount: null,
                    apartment_number: null,
                    client: null,
                    client_id: null,
                    created_at: null,
                    credit_price: model.credit_price,
                    credit_price_with_vat: model.credit_price_with_vat,
                    deleted_at: null,
                    final_price: null,
                    finalized_at: null,
                    garden_surface: model.garden_surface,
                    id: this.newItemId,
                    level: level,
                    level_id: levelId,
                    model: model,
                    notes: null,
                    price: model.price,
                    price_with_vat: model.price_with_vat,
                    project_building_id: buildingId,
                    project_id: model.project_id,
                    project_model_id: model.id,
                    show_status_for_agencies: 0,
                    show_status_for_clients: 0,
                    status: 'available',
                    terrace_surface: model.terrace_surface,
                    type: model.type,
                    updated_at: null,
                    useful_surface: model.useful_surface,
                };
                this.newItemId--;

                // add item and "reload"
                this.reloadLevelId = levelId;
                building.items.unshift(item);
                this.setBuildingsFilter(building);
                this.reloadLevelId = null;

                // inline edit form
                this.openEditInlineModelItem(item);
            },
        }
    }
</script>